<template>
  <div class="item" @click="handleClick()">
    <input
      type="radio"
      :id="label"
      :name="name"
      :value="value"
      :checked="isSelected"
    />
    <label :for="label" :class="label" tabindex="0">
      <div class="shape">
        <slot name="activeImage"></slot>
        <slot name="inactiveImage"></slot>
      </div>
      <p>{{ label }}</p>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Number
    },
    label: {
      required: true,
      type: String
    },
    name: {
      required: true,
      type: String
    }
  },
  computed: {
    isSelected: function() {
      const { value: currentValue } = this.getSingleSelectState();
      return currentValue === this.value;
    }
  },
  methods: {
    handleClick() {
      const { set } = this.getSingleSelectState();
      set(this.value);
    },

    handleKeyDown(event) {
      if (event.keyCode === SPACEBAR) {
        this.handleClick();
        event.preventDefault();
      }
    }
  },
  inject: ["getSingleSelectState"]
};
</script>
